<template>
	<div id="app" v-if = "loaded" :class="{ 'mhd' : ! $root.isTOK}">
		<router-view></router-view>
		<Notification></Notification>
		<FooterNav></FooterNav>
	</div>
</template>
<style>
.table tr th,
.table tr td{
	padding:10px;
	text-align:left;
	vertical-align:top;
}
.table button{
	margin-right:10px;
}
.table .table tr th,
.table .table tr td{
	padding-top:0;padding-left:0;padding-bottom:5px;
}
</style>
<script>
import Notification from "./components/Notification.vue";
import FooterNav from "./components/FooterNav.vue";
export default {
	components:{
		Notification,
		FooterNav 
	},
	name: 'App',
	//=========================================================//
	//                                                         //
	//                            DATA                         //
	//                                                         //
	//=========================================================//
	data(){
		return {
			merchantAds: {},
			loaded: false,
		}
	},
	mounted(){
		if (window.location.href.includes("/#/")){
			window.location = window.location.href.replace("/#/","/");
		}
	},
	firestore(){
		var dbPath = "settings";
		var docID = "merchantAds";
		this.$binding("merchantAds", myFB.db.collection(dbPath).doc(docID)).then(r2=>{
			this.loaded =true;
		}).catch(e=>{
			this.loaded =true;
			console.log(e.message);
		})
	},
};
</script>



// WEBPACK FOOTER //
// src/App.vue